import findItemToLoad from './findItemToLoad';
import type Item from 'owa-service/lib/contract/Item';
import shouldCreateItemPartViewState from './shouldCreateItemPartViewState';
import { getStore } from '../store/Store';

export function getItemFromNodeId(nodeId: string): Item {
    const conversationNode = getStore().conversationNodes.get(nodeId);
    const [item, isLocal, isDeleted] = findItemToLoad(conversationNode);
    if (!shouldCreateItemPartViewState(item, isDeleted, isLocal)) {
        return null;
    } else {
        return item;
    }
}

export { findItemToLoad, shouldCreateItemPartViewState };
